import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EXPAND_BEHAVIORS } from '../constants';

const SearchInputContainer = ({ expandBehavior, isExpanded, ...other }) => {
  return <StyledSearchInputContainer $expandBehavior={expandBehavior} $isExpanded={isExpanded} {...other} />;
};

const StyledSearchInputContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: ${({ $expandBehavior }) =>
    $expandBehavior === EXPAND_BEHAVIORS.SLIDE_LEFT ? 'flex-end' : 'flex-start'};
  position: relative;
  width: 100%;
  :focus-within {
    &:hover {
      background-color: ${({ $isExpanded, theme }) => !$isExpanded && theme.color.state.default.hover.value};
    }
    &:active {
      background-color: ${({ $isExpanded, theme }) => !$isExpanded && theme.color.state.default.pressed.value};
    }
  }
`;

SearchInputContainer.propTypes = {
  /** Defines Search Input expanding behaviour */
  expandBehavior: PropTypes.oneOf(Object.values(EXPAND_BEHAVIORS)),
  /** If true, search input is expanded */
  isExpanded: PropTypes.bool,
};

export { SearchInputContainer };
